import { useMemo } from 'react'
import { Label } from '../__gql-types'
import { formatLabelOptions, formatToOptions, formatUnitsToOptions, getCountryCodes, getUnits } from '../utils/labels'

/**
 * 
 * @deprecated use useZoneList 
 * 
 */
export const useFormattedZoneList = (zoneList: Label[], currentZone: string = '') => {
  const zoneOptions = useMemo(() => zoneList.map(formatToOptions), [zoneList])
  const zoneSelectOptions = useMemo(() => formatLabelOptions(zoneList), [zoneList])
  const units = useMemo(() => getUnits(zoneList, currentZone), [zoneList, currentZone])
  const unitOptions = useMemo(() => formatUnitsToOptions(zoneList, currentZone), [currentZone, zoneList])
  const countryCodes = useMemo(() => getCountryCodes(zoneList, currentZone), [currentZone, zoneList])
  const zoneById = useMemo(
    () => zoneList.reduce<Record<string, Label>>((zoneById, zone) => ({ ...zoneById, [zone?.id ?? '']: zone }), {}),
    [zoneList],
  )

  return {
    units,
    zoneOptions,
    unitOptions,
    countryCodes,
    zoneSelectOptions,
    zoneById
  }
}
